export enum ToasterEnum {
  SUCCESS = 'Success',
  ERROR = 'Error'
}
